<template>
    <div>
        <shop-head currentPageName="businees_publish"></shop-head>
        <div class="content mt-10 mb-10">
            <div class="container ">
                <el-form class=""  ref="formRef" :model="form" :rules="rules" label-width="250px" size="small"
                    style="width: 900px;" label-position="right">
                    <el-form-item :label="$t('商机标题') + ' :'" prop="title" required >
                        <el-input v-model="form.title" :placeholder="$t('请简短描述您的商机主题')" />
                    </el-form-item>
                    <el-form-item :label="$t('商机类型') + ' :'">
                        <el-button @click="picktime(item)" v-for="item in pickTiem" :key="item.id"
                            :type="item.selected ? 'primary' : ''" plain size="small">
                            {{ $t(item.label)}}
                        </el-button>
                    </el-form-item>
                    <el-form-item :label="$t('其他商机类型：') + ' :'" v-if="IsOther" >
                        <el-input v-model="form.typeName" :placeholder="$t('请简短描述您的商机类型')" />
                    </el-form-item>
                    <el-form-item :label="$t('产品分类') + ' :'">
                        <el-select v-model="form.category" :placeholder="$t('所有')" >
                            <el-option v-for="(item,index) in category_All" :key="item.index" :label="lang == 'zh'?item.note:item.keyS"
                                :value="item.note" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('商机产品') + ' :'" prop="product" required>
                        <el-input type="textarea" v-model="form.product" :placeholder="$t('您的商机主要针对的产品')" :rows="6"></el-input>
                        <el-upload class="upload-demo" 
                        action="" 
                        :file-list="fileRootList" 
                        :http-request="UploadRoot"
                        :on-success="handleSuccess"
                            >
                            <el-button size="mini" type="primary">{{$t('上传')}}</el-button>
                        </el-upload>
                    </el-form-item>
                    <el-form-item :label="$t('发布人') + ' :'" prop="publisher" required>
                        <el-input v-model="form.publisher" :placeholder="$t('请输入您的名字')" />
                    </el-form-item>
                    <el-form-item :label="$t('发布人手机号') + ' :'" prop="phone" required>
                        <el-input v-model="form.phone" :placeholder="$t('请输入您的手机号')" />
                    </el-form-item>
                    <el-form-item :label="$t('发布人公司') + ' :'">
                        <el-select v-model="form.companyName" :placeholder="$t('所有')" @change="handleCompanyChange">
                            <el-option v-for="item in companyNameList" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('附加材料') + ' :'">
                        <el-upload class="upload-demo" ref="upload" action="" :before-upload="beforeUpload"
                            :on-preview="handlePreview" :on-remove="imagesRemove" :file-list="fileList"
                            :http-request="Upload" :on-success="fileChange" list-type="picture">
                            <el-button slot="trigger" size="small" type="primary">{{$t('选取文件')}}</el-button>
                            <div slot="tip" class="el-upload__tip" style="color:#c8c8c8">{{$t('支持上传图片或文件')}}</div>
                        </el-upload>
                    </el-form-item>
                    <el-form-item>
                        <el-button class="mr-10 ml-20"  type="primary" @click="handleSubmit">
                            {{$t('发布')}} 
                        </el-button>
                        <el-button @click="() => {
                            this.$router.push({ name: 'business' });
                        }">
                            {{$t('取消')}} 
                        </el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <common-footer></common-footer>
    </div>
</template>
<script>
import shopHead from '../../components/shop/head'
import commonFooter from '../../components/common/footer'
import { updatacompany, companyList, createcompany, uploadInfo, findChildsByKey,findCategoryAll } from '../../apis/businees_publish'
import {loginInfo} from '../../apis/user'
export default {
    components: {
        shopHead,
        commonFooter,
    },
    data() {
        const pickTiem = [{ label: '供应', id: 1, selected: false }, { label: '需求', id: 2, selected: false }, { label: '合作', id: 3, selected: false }, { label: '招商', id: 4, selected: false },{ label: '其他', id: 5, selected: false }];
        //const pickTiem = []
        const { id = '', details = '', name = '', secondName = '', type, status, check, images = '' } = this.$route.params;
        let fileList = images.split(',').filter((item) => item != '');
        fileList = fileList.map((item) => ({ url: item }));
        return {
            isSubmitting: false,
            fileList: [],
            fileRootList: [],
            form: {
                material: images || '',
                title: '',
                publisher: '',
                phone: '',
                companyName: '',
                companyId: '',
                product: '',
                type,
                typeName: '',
                businessDirectory:'',
                category:''
            },
            rules: {
                title: [{ required: true, message: this.$t('请输入商机标题') }],
                publisher: [{ required: true, message: this.$t('请输入发布人') }],
                phone: [{ required: true, message:  this.$t('请输入手机号码')  },
                { pattern: /^1[3-9]\d{9}$/, message: this.$t('请输入有效的手机号码') }],
                companyName: [{ required: true, message: this.$t('请输入公司名称')}],
                product: [{ required: true, message: this.$t('请输入您的商机主要针对的产品') }]
            },
            // 公司列表
            companyNameList: [],
            // 类型选择
            pickTiem,
            typeName: '',
            // 其他类型文本框
            IsOther: false,
            newFile: new FormData(),
            // 全部类别
            category_All:[]
        }
    },
    activated() {
    },
    created() {
        this.lang = localStorage.getItem("language") == "zh" ? "zh" : "en";
        this.getList()
    },
    methods: {
        // 表单提交
        handleSubmit() {
            // 表单认证
            this.$refs.formRef.validate(async (valid) => {
                if (valid) {
                      //const result = await createcompany(this.form)
                      console.log(this.form)
                    // if (result.code === 200) {
                    //     this.$message.success(this.$t('新增商机成功'))
                    //     this.$router.push({ name: 'business' })
                    // } else {
                    //     this.$message.error(this.$t('新增商机失败'))
                    // }

                } else {
                    this.$message.error(this.$t('请检查输入项！'));
                    return false; // 阻止请求的发起
                }
            })
        },
        // 公司查询
        handleCompanyChange(newValue) {
            this.form.companyId = newValue
            //通过 companyId 查找对应的 companyName
            const selectedCompany = this.companyNameList.find(item => item.value === newValue);
            if (selectedCompany) {
                this.form.companyName = selectedCompany.label;  // 将对应的 companyName 赋值给 form.companyName
            } else {
                this.form.companyName = '';  // 如果没有找到公司，清空 companyName
            }
        },
        // 按钮选择
        picktime(e) {
            
            if (e.id === 5) {
                this.form.typeName = ''
                this.IsOther = true
            } else {
                this.IsOther = false
                // 更新数据 
                this.form.typeName = e.label
            } 
            // 改变选中状态
            this.form.type = e.id
            this.pickTiem.forEach(item => {
                item.selected = false
            })
            e.selected = !e.selected;
        },
        // 材料点击
        handlePreview(e) {
            const { url, name } = e
            let temp
            if (this.IsImgs(name)) {
                temp = url
                console.log(temp)
            } else {
                const match = url.match(/^(https?:\/\/[^/]+)/);
                temp = `${match[0]}/${name}`
                console.log(temp)
            }
            window.open(temp, '_blank');

        },
        // 上传图片之前调用
        beforeUpload(file) {
            if (file) {
                this.newFile.append('file', file);
            } else {
                return false;
            }
        },
        // 文件上传
        Upload({ file, onSuccess, onError }) {
            const newData = {
                file: file
            }
            uploadInfo(newData).then(res => {
                console.log(res)
                if (res.code === 200) {
                    console.log(123)
                    onSuccess(res.data);
                } else {
                    onError(new Error(this.$t('上传失败')));
                }
            });


            // let temp = {
            //   name :file.name,
            //   url:res
            // }
            // this.fileList.push(temp)

        },
        // 上传文件成功后
        fileChange(response, file, fileList) {
            this.$refs.upload.clearFiles()
            const url = this.IsImgs(response) ? response : 'https://aptoto-img-test.oss-cn-shenzhen.aliyuncs.com/gyh0cd9c37b6ed5474995161b98144721ffpackage.png'
            let temp = {
                name: file.name,
                url,
            }
            this.fileList.push(temp)
            this.handleAvatarSuccess(response)
            console.log(this.fileList)
        },
        // 上传图片
        handleAvatarSuccess(data) {
            //console.log(data)
            let images = this.form.material.split(',').filter((item) => item != '');
            images.push(data);
            images = images.join(',');
            this.form.material = images;
        },
        // 删除图片
        imagesRemove(e) {
            let temp = e.url
            if (!this.IsImgs(e.name)) {
                // 文件地址拼接
                const match = e.url.match(/^(https?:\/\/[^/]+)/);
                temp = `${match[0]}/${e.name}`
            }
            let images = this.form.material.split(',').filter((item) => item != '');
            if (temp) {
                images = images.filter((item) => item != temp);
            }
            images = images.join(',');
            this.form.material = images;
            console.log(this.form)



        },
        // 判断是否为图片
        IsImgs(url) {
            // 定义常见的图片文件扩展名
            const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
            // 获取后序
            const extension = url.slice(url.lastIndexOf('.')).toLowerCase();
            return imageExtensions.includes(extension);
        },
        // 获取数据
        async getList() {
            const { data } = await companyList()
            //公司列表 
            data.forEach(item => {
                const tempCompanyList = {
                    value: item.id,
                    label: item.companyName
                }
                this.companyNameList.push(tempCompanyList)
            });
            //  商机类型
            // const buttomList = await findChildsByKey('商机类型')
            // buttomList.data.forEach(item => {
            //     this.pickTiem.push({
            //         label: item.note,
            //         id: Number(item.keyS),
            //         selected: false
            //     })
            // })

            // 产品分类类型
           this.category_All =(await findCategoryAll ()).data;
            //获取个人信息 
           this.getInfo()


        },
        // 上传商机根目录
        UploadRoot({ file, onSuccess, onError }) {
            const newData = {
                file: file
            }
            uploadInfo(newData).then(res => {
                if (res.code === 200) {
                    onSuccess(res.data);
                } else {
                    onError(new Error('上传失败'));
                }
            });
        },
        // 商品根目录上传成功回调函数
        handleSuccess(file){
            this.form.businessDirectory=file
        },
        // 个人信息查询
        async getInfo(){
           const {data} =  await loginInfo () ;
           this.form.companyId = data.companyId
           this.form.phone = data.phone
           this.form.companyName   =data.companyName
           //this.form.type = data.type
           this.form.publisher = data.nickname
            // 商机类型赋值    
            const info = this.pickTiem.filter(item=>(item.id === 2))
            this.picktime(info[0])
        }
        



    }
}
</script>
<style>
.content {
    .container {
        background-color: white;
        padding: 20px;

    }
}
</style>
